$(document).ready(function() {
    navigationDropdownPosition('.top-nav .level-2', 'position-left', 'position-right');
});

$(window).resize(function() {
    navigationDropdownPosition('.top-nav .level-2', 'position-left', 'position-right');
});

